import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M9 1.8a1.2 1.2 0 0 0-1.14.82L5.13 10.8H2A1.2 1.2 0 0 0 .8 12 1.2 1.2 0 0 0 2 13.2h4a1.2 1.2 0 0 0 1.14-.82L9 6.8l4.86 14.6a1.2 1.2 0 0 0 2.28 0l2.73-8.18H22a1.2 1.2 0 0 0 1.2-1.2 1.2 1.2 0 0 0-1.2-1.2h-4a1.2 1.2 0 0 0-1.14.82L15 17.22l-4.86-14.6A1.2 1.2 0 0 0 9 1.8" }, null, -1)
  ]))]))
}
export default { render: render }